import { Creative } from '@/views/creatives/interfaces';
import { PLAY_PRODUCT } from './productsList';
import { CREATIVE_PLAY, CREATIVE_PLAY_NEW, CREATIVE_BASE, CREATIVE_FOLDER_ITEM,
  CREATIVE_PLAY_HOTSPOT, CREATIVE_CANVAS_BLANK, CREATIVE_CANVAS_POPULATED, CREATIVE_FOLDER_ITEM_2 } from './creativeDetail';

export const CREATIVES_LIST: Creative[] = [
  {
    ...CREATIVE_PLAY_NEW,
    createdAt: '2022-02-07T10:00:00.000Z',
    updatedAt: '2022-02-07T10:00:00.000Z',
  },
  {
    ...CREATIVE_PLAY,
    createdAt: '2022-02-07T11:00:00.000Z',
    updatedAt: '2022-02-07T11:00:00.000Z',
  },
  {
    ...CREATIVE_PLAY_HOTSPOT,
    createdAt: '2022-02-07T09:00:00.000Z',
    updatedAt: '2022-02-07T09:00:00.000Z',
  },
  {
    ...CREATIVE_BASE,
    createdAt: '2022-02-07T12:00:00.000Z',
    updatedAt: '2022-02-07T12:00:00.000Z',
  },
  {
    ...CREATIVE_CANVAS_BLANK,
    id: 'cre_ko2BK2',
    name: 'Canvas Creative',
    createdAt: '2022-02-07T08:00:00.000Z',
    updatedAt: '2022-02-07T08:00:00.000Z',
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BB5',
    name: 'Second Creative',
    status: 'draft',
    type: PLAY_PRODUCT,
    createdAt: '2022-04-28T12:00:00.000Z',
    updatedAt: '2022-04-28T12:00:00.000Z',
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BK3',
    name: 'Third Creative',
    creativeId: 'webBjUFhNe3',
    status: 'draft',
    type: PLAY_PRODUCT,
    createdAt: '2022-04-28T11:00:00.000Z',
    updatedAt: '2022-04-28T11:00:00.000Z',
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BK4',
    name: 'Fourth Creative',
    status: 'draft',
    type: PLAY_PRODUCT,
    createdAt: '2022-04-28T10:00:00.000Z',
    updatedAt: '2022-04-28T10:00:00.000Z',
    coverImageS3Url: 'https://development-alanparsons-api-bucketst-assetsbucket-ije2ob0jckz9.s3.us-east-1.amazonaws.com/cover-images/1i7oRRbEGsq/new3_1665047071046.png',
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BK5',
    name: 'Fifth Creative',
    createdAt: '2022-04-28T09:00:00.000Z',
    updatedAt: '2022-04-28T09:00:00.000Z',
    data: {
      frames: [],
      instances: {},
      iterations: {},
    },
  },
  {
    ...CREATIVE_CANVAS_BLANK,
    id: 'cre_ko2BK6',
    name: 'Sixth Creative',
    createdAt: '2022-04-28T08:00:00.000Z',
    updatedAt: '2022-04-28T08:00:00.000Z',
  },
  {
    ...CREATIVE_CANVAS_POPULATED,
    id: 'cre_ko2BT2',
    name: 'Demo Canvas Creative 2',
    createdAt: '2022-04-01T17:54:15.000Z',
    updatedAt: '2022-04-01T17:54:15.000Z',
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BS1',
    name: 'First Archived Creative',
    archivedAt: '2022-04-28T17:54:15.000Z',
    isArchived: true,
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BS2',
    name: 'Second Archived Creative',
    archivedAt: '2022-04-01T17:54:15.000Z',
    isArchived: true,
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BV1',
    name: 'First Deleted Creative',
    deletedAt: '2022-04-28T17:54:15.000Z',
  },
  {
    ...CREATIVE_PLAY,
    id: 'cre_ko2BV2',
    name: 'Second Deleted Creative',
    deletedAt: '2022-04-01T17:54:15.000Z',
  },
  { ...CREATIVE_FOLDER_ITEM },
  { ...CREATIVE_FOLDER_ITEM_2 },
];

export default CREATIVES_LIST;
